import React, { Component } from 'react'
import Helmet from 'react-helmet'
import ImageArea from '~/components/ImageArea'
import Button from '~/components/Button'
import SVG from '~/components/SVG'
import {
  initOpenInApp,
  checkIsHybridable,
  checkIsLogin,
  universalOpenUrl,
  universalToast,
} from '~/utils'
import { setWowBadge, getWowBadge, getCurrentUser } from '~/services'
import styles from './index.css'

const BADGES = {
  1: {
    name: '联盟',
    imgKey: 'urlIconUnion',
  },
  2: {
    name: '部落',
    imgKey: 'urlIconTribe',
  },
}

const VALID_BADGE_TYPES = [1, 2]

export default class Wow extends Component {
  state = {
    userAvatar: '',
    userIsOrg: false,
    result: -1,
    badgeImgUrl: '',
  }

  componentDidMount() {
    window.addEventListener('load', this.handlePageInit)
  }

  componentWillUnmount() {
    window.removeEventListener('load', this.handlePageInit)
  }

  getCurrentUserInfo = () => {
    getCurrentUser()
      .then(({ data }) => {
        this.setState({
          userName: data.name,
          userAvatar: data.avatar_url_template.replace('{size}', 'l'),
          userUrlToken: data.url_token,
          userIsOrg: data.is_org,
        })
      })
      .catch(this.handleUnLogin)
  }

  handlePageInit = () => {
    initOpenInApp()
      .then(() => {
        checkIsHybridable().then(() => {
          checkIsLogin()
            .then(this.handleBadgeChange)
            .catch(this.handleUnLogin)
        })
      })
      .catch()
  }

  handleBadgeChange = () => {
    const { match: { params: { type } = {} } = {} } = this.props
    const badgeType = Number(type)

    if (!VALID_BADGE_TYPES.includes(badgeType)) {
      this.handleSaveBadgeFail()
      return
    }

    this.getCurrentUserInfo()

    setWowBadge({ badgeType, status: 1 })
      .then(() => {
        getWowBadge().then(({ data }) => {
          const badgeInfo = BADGES[data.badgeType]
          if (badgeInfo) {
            this.setState({
              result: data.badgeType,
              badgeImgUrl: data[badgeInfo.imgKey],
            })
          } else {
            this.handleSaveBadgeFail()
          }
        })
      })
      .catch(this.handleSaveBadgeFail)
  }

  handleUnLogin = () => {
    this.setState({ result: 0 })
  }

  handleSaveBadgeFail = () => {
    universalToast('徽章领取失败', 'fail')
    this.setState({ result: 3 })
  }

  handleProfileButtonClick = urlToken => () => {
    const { userIsOrg } = this.state
    universalOpenUrl(
      `https://www.zhihu.com/${userIsOrg ? 'org' : 'people'}/${urlToken}`
    )
  }

  handleLogin = () => {
    checkIsLogin()
      .then(this.handleBadgeChange)
      .catch(this.handleUnLogin)
  }

  render() {
    const {
      userName,
      userAvatar,
      userUrlToken,
      result,
      badgeImgUrl,
    } = this.state

    return (
      <div className={styles.wowCampaign}>
        <Helmet title="「魔兽世界」限时专属徽章" />
        {result === 0 && (
          <div className={styles.wowCampaignResult}>
            <ImageArea
              className={styles.wowCampaignUserAvatar}
              src={userAvatar}
            />
            <p className={styles.wowCampaignFailureTip}>尚未登录</p>
            <Button
              className={styles.wowCampaignRetryButton}
              onClick={this.handleLogin}
            >
              登录
            </Button>
          </div>
        )}
        {VALID_BADGE_TYPES.includes(result) && (
          <div className={styles.wowCampaignResult}>
            <p className={styles.wowCampaignSuccessTip}>
              <SVG name="" />
              成功领取{BADGES[result].name}徽章！
            </p>
            <ImageArea
              className={styles.wowCampaignUserAvatar}
              src={userAvatar}
            />
            <div className={styles.wowCampaignUserName}>
              {userName}
              {badgeImgUrl && (
                <ImageArea
                  className={styles.wowCampaignUserBadge}
                  src={badgeImgUrl}
                />
              )}
            </div>
            <p className={styles.wowCampaignSuccessDesc}>
              你已成功领取 {BADGES[result].name} 徽章
              <br />
              徽章将展示在你的回答、文章、想法及个人主页中
            </p>
            {userUrlToken && (
              <Button
                className={styles.wowCampaignProfileButton}
                onClick={this.handleProfileButtonClick(userUrlToken)}
              >
                进入我的个人主页
              </Button>
            )}
          </div>
        )}
        {result === 3 && (
          <div className={styles.wowCampaignResult}>
            <ImageArea
              className={styles.wowCampaignUserAvatar}
              src={userAvatar}
            />
            <p className={styles.wowCampaignFailureTip}>徽章领取失败</p>
            <Button
              className={styles.wowCampaignRetryButton}
              onClick={this.handleBadgeChange}
            >
              再试一次
            </Button>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Campaign/Wow/index.js